<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box-name">
      <div class="select-label">{{appName}}</div>
    </div>
    <div class="select-box input_left">
      <Input v-model="searchVer" style="width:150px;" placeholder="请输入版本号"/>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <div class="option-wrap">
      <Row>
        <Col>
          <Button type="primary" @click="newAlert"><Icon type="md-add" size="15" /> 上传卡片新版本</Button>
        </Col>
      </Row>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      title="上传版本"
      :loading="loading"
      @on-cancel="closeModal"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="apkInfo" :rules="ruleValidate" :label-width="120">
        <!-- <FormItem label="ID" prop="cardId">
          <Input v-model="apkInfo.cardId" :disabled="true" placeholder="卡片ID" />
        </FormItem>
        <FormItem label="名称" prop="cardName">
          <Input v-model="apkInfo.cardName" :disabled="true" placeholder="卡片名称" />
        </FormItem> -->
         <FormItem label="文件上传" prop="filePath" v-if="newdata">
          <Upload type="file" accept='.zip' :onSuccess="filesuccess" :headers="headers" :action="baseUrl + '/extscreenapi/plugin/hili/card/uploadFile'">
              <Button icon="ios-cloud-upload-outline">上传</Button>
          </Upload>
          <div style="font-size:12px;">文件格式为zip，将项目编译后dist文件夹中的Android文件夹进行压缩上传至此处</div>
        </FormItem>
        <FormItem label="版本号" prop="versionCode">
          <Input v-model="apkInfo.versionCode" placeholder="请输入版本号，需两段，以一个小数点分割。例：1.01" />
        </FormItem>
        <FormItem label="SDK最小版本" prop="sdkVersion">
          <!-- <Input v-model="apkInfo.sdkVersion" placeholder="请输入sdk最小版本号，需三段，以两个小数点分割。例：1.0.1701" /> -->
          <Select
                v-model="apkInfo.sdkVersion"
                placeholder="请选择版本"
                filterable
                >
                <Option v-for="(option, index) in sdkVerList" :value="option.value" :tag="option" :key="index">{{option.text}}</Option>
            </Select>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="apkInfo.remark" placeholder="备注最大字数为30字" maxlength="30" type="textarea" :rows="4" />
        </FormItem>
        <!-- <FormItem label="路径" prop="filePath">
          <Input type="textarea" :rows="4"  v-model="apkInfo.filePath" :disabled="true" placeholder="文件路径" />
        </FormItem>
        <FormItem label="md5" prop="md5">
          <Input type="textarea" :rows="4"  v-model="apkInfo.md5" :disabled="true" placeholder="文件md5" />
        </FormItem> -->
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../../https'
export default {
  name: 'version',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      cardId: '',
      appName: '',
      apksList: [],
      searchVer: '',
      sdkVerList: [],
      headers: {
        'satoken': https.token
      },
      search: {
        name: ''
      },
      formValidate: {
        remark: '',
        fileName: '',
        files: '',
        refresh: '关闭'
      },
      apkInfo: {
        cardName: '',
        filePath: '',
        md5: '',
        cardId: '',
        versionCode: '',
        remark: '',
        sdkVersion: ''
      },
      ruleValidate: {
        filePath: {required: true, message: '请上传zip包'},
        versionCode: { required: true, pattern: /^(\d+\.\d{0,2}|\d+)$/, message: '请输入版本号，需两段，以一个小数点分割。例：1.01' }
        // sdkVersion: { required: false, pattern: /^\d+(\.\d{1,4}){0,2}$/, message: '请输入sdk最小版本号，需三段，以两个小数点分割。例：1.0.1701' }
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: '版本号',
          key: 'maxVersionStr',
          minWidth: 100
        },
        {
          title: 'SDK最小版本号',
          key: 'sdkVersion',
          minWidth: 150,
          render: (h, params) => {
            let sdkVersion = ''
            if (params.row.sdkVersion.length > 0) {
              sdkVersion = params.row.sdkVersion
            } else {
              sdkVersion = '不限'
            }
            let html = [
              h('span', sdkVersion)
            ]
            return html
          }
        },
        {
          title: '上传时间',
          key: 'createTime',
          minWidth: 200
        },
        {
          title: '发布时间',
          key: 'updateTime',
          minWidth: 200
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 200
        },
        {
          title: '操作',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            // let arr = []
            if (this.dataList.length === 1) {
              return h('div', [])
            } else {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    width: '50px',
                    marginRight: '10px'
                  },
                  on: {
                    click: () => {
                      this.delItem(params.row.id)
                    }
                  }
                }, '删除')
              ])
            }
          }
        }
      ],
      baseUrl: '',
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1, // 当前页
      imgUrl: ''
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.baseUrl = process.env.API_HOST
    this.cardId = this.$route.query.cardId
    this.appName = this.$route.query.cardName
    this.apkInfo.cardName = this.$route.query.cardName
    this.apkInfo.cardId = this.$route.query.cardId
    this.loadData()
  },
  methods: {
    getVerList () {
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=runtime_sdk_version'
      }).then(res => {
        console.log(res)
        this.sdkVerList = res.result
      })
    },
    filesuccess (e) {
      this.apkInfo.filePath = e.result.filePath
      this.apkInfo.md5 = e.result.fileMd5
    },
    changeAuditState (val) {
      if (val) {
        this.loadData(val)
      }
    },
    clearAuditState () {
      this.loadData()
    },
    // 加载tabs列表
    loadData (state = 0) {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.current,
        cardId: this.cardId,
        versionCode: this.searchVer,
        query: state
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/card/list',
        params: params
      }).then(res => {
        console.log(res.result.records)
        this.tableLoading = false
        this.dataList = res.result.records
        this.total = res.result.total
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchVer = ''
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    newAlert (row = {}) {
      this.getVerList()
      if (Object.keys(row).length > 1) {
        this.apkInfo = {
          versionCode: row.versionCode,
          remark: row.remark,
          md5: row.md5,
          filePath: row.filePath,
          cardName: row.cardName,
          cardId: row.cardId,
          sdkVersion: row.sdkVersion
        }
        this.editId = row.id
      } else {
        this.apkInfo = {
          versionCode: '',
          remark: '',
          md5: '',
          filePath: '',
          sdkVersion: '全部',
          cardName: this.$route.query.cardName,
          cardId: this.$route.query.cardId
        }
        this.editId = ''
      }
      this.newdata = true
    },
    delItem (id) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p class="del-modal-txt">确定要删除吗？</p>',
        onOk: () => {
          https.request({
            method: 'DELETE',
            url: 'extscreenapi/plugin/hili/card/delete?id=' + id,
            data: {id: id}
          }).then(res => {
            this.$Message.success('删除成功')
            this.loadData()
          })
        }
      })
    },
    closeModal () {
      this.$refs['formValidate'].resetFields()
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.apkInfo.md5.length === 0) {
            this.$Message.success('请上传代码包')
            this.changeLoading()
            return
          }
          if (this.apkInfo.versionCode.length === 0) {
            this.$Message.success('请填写版本号')
            this.changeLoading()
            return
          }
          setTimeout(() => {
            this.changeLoading()
            console.log(this.apkInfo)
            if (this.editId.length > 0) {
              https.request({
                method: 'put',
                url: 'extscreenapi/plugin/hili/card/edit',
                data: {...this.apkInfo, id: this.editId}
              }).then(res => {
                this.$Message.success('编辑成功')
                this.closeModal()
                this.newdata = false
                this.editId = ''
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            } else {
              https.request({
                method: 'post',
                url: 'extscreenapi/plugin/hili/card/add',
                data: this.apkInfo
              }).then(res => {
                if (res.code === 500) {
                  this.$Message.error('版本号不能重复')
                  return
                }
                this.$Message.success('上传成功')
                this.closeModal()
                this.newdata = false
                this.editId = ''
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .code-box {
    display: inline-block;
    border: 1px solid #dcdee2;
    padding: 15px;
    text-align: center;
    line-height: 1;
  }
  .code-box p {
    margin-top: 15px;
  }
  .code-box img {
    width:200px;
    height:200px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 260px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
      font-weight: bold;
      font-size:20px;
    }
  }
  .select-box-name{
    display: flex;
    position: absolute;
    top: 20px;
    right:28px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
      font-weight: bold;
      font-size:20px;
    }
  }
  .select_icon_url{
    width: 30px;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  }
  .input_left_three{
    left:430px;
  }
</style>



// WEBPACK FOOTER //
// src/components/esCard/versionCard.vue